module.exports = require('./helpers/bundle-url').getBundleURL('jDW3t') + "logo.7718c6df.svg";